export const API_URL = process.env.VUE_APP_STOCK_ALARM_SERVICE_URL;

export default API_URL;
